import {
  BrandVariants,
  createDarkTheme,
  createLightTheme,
} from '@fluentui/react-components';

export const nexusBrand: BrandVariants = {
  10: '#020505',
  20: '#091B1F',
  30: '#0B2D35',
  40: '#0C3D47',
  50: '#0C4D5A',
  60: '#0B5E6E',
  70: '#087082',
  80: '#028297',
  90: '#1994A8',
  100: '#34A5B7',
  110: '#4FB6C5',
  120: '#6BC7D3',
  130: '#88D7DF',
  140: '#A6E6EB',
  150: '#C5F2F5',
  160: '#E5FAFB',
};

export const lightTheme = createLightTheme(nexusBrand);
export const darkTheme = createDarkTheme(nexusBrand);
